import { Grid } from "@mui/material";
import { FC, useEffect } from "react";
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import HeaderV3 from "./HeaderV3";
import { useTicketStore } from "../../../hooks/useTicketStore";
import { useAuthStore } from "../../../hooks/useAuthStore";
import { ApiStatus } from "../../../types/api/status";
import { useNavigate } from "react-router-dom";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'date', label: 'Fecha', align:'center' },
    { type: 'text', field: 'type_document', label: 'Tipo', align:'center' },
    { type: 'text', field: 'net_total', label: 'Total neto', align:'center' },
    { type: 'text', field: 'total_discount', label: 'Descuento', align:'center', format: (row) => row.total_discount || '0' },
    { type: 'text', field: 'IVA', label: 'IVA', align:'center' },
    { type: 'text', field: 'total', label: 'Total', align:'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align:'center' },
]

export const TicketListV3:FC = () => {
    
    const navigate = useNavigate()
    const { user } = useAuthStore()
    const { status, tickets, getTicket, deleteTicket } = useTicketStore()

    useEffect(() => {
        getTicketApi()
    },[])

    const getTicketApi = async () => {
        await getTicket({ status_invoice: '0', iduser_created: user.id })
    }

    const onDelete = async (rowSelected) => {
        const response = await deleteTicket(rowSelected.id)
        if (response === true) getTicketApi()
    }

    const onDetails = (rowSelected) => {
        if (rowSelected.id) navigate(`/preview-document/${rowSelected.id}`)
    }

    return (
        <>
        <HeaderV3/>
        <Grid item xs={12}>
            <CustomTable 
                title={'Mis tickets'}
                columns={columns} 
                rows={tickets || []}
                loading={status === ApiStatus.FETCHING}
                onRowClick={() => {}}
                hasOptions
                onDelete={onDelete}
                onDetails={onDetails}
                dense
            />
        </Grid>
        </>
    )
}